/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SummaryTableTittleDto } from './SummaryTableTittleDto';
import {
    SummaryTableTittleDtoFromJSON,
    SummaryTableTittleDtoFromJSONTyped,
    SummaryTableTittleDtoToJSON,
} from './SummaryTableTittleDto';

/**
 * 
 * @export
 * @interface DrmSummaryTableDto
 */
export interface DrmSummaryTableDto {
    /**
     * 
     * @type {string}
     * @memberof DrmSummaryTableDto
     */
    section?: DrmSummaryTableDtoSectionEnum;
    /**
     * 
     * @type {Array<SummaryTableTittleDto>}
     * @memberof DrmSummaryTableDto
     */
    schema: Array<SummaryTableTittleDto>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DrmSummaryTableDto
     */
    aggregatedData?: { [key: string]: any; };
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof DrmSummaryTableDto
     */
    data?: Array<{ [key: string]: any; }>;
}


/**
 * @export
 */
export const DrmSummaryTableDtoSectionEnum = {
    TopHole: 'TOP_HOLE',
    TopHole2: 'TOP_HOLE_2',
    Conductor: 'CONDUCTOR',
    TechnicalCasing: 'TECHNICAL_CASING',
    IntermediateCasing: 'INTERMEDIATE_CASING',
    ProductionCasing: 'PRODUCTION_CASING',
    ProductionLiner: 'PRODUCTION_LINER',
    Liner: 'LINER'
} as const;
export type DrmSummaryTableDtoSectionEnum = typeof DrmSummaryTableDtoSectionEnum[keyof typeof DrmSummaryTableDtoSectionEnum];


/**
 * Check if a given object implements the DrmSummaryTableDto interface.
 */
export function instanceOfDrmSummaryTableDto(value: object): value is DrmSummaryTableDto {
    if (!('schema' in value) || value['schema'] === undefined) return false;
    return true;
}

export function DrmSummaryTableDtoFromJSON(json: any): DrmSummaryTableDto {
    return DrmSummaryTableDtoFromJSONTyped(json, false);
}

export function DrmSummaryTableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrmSummaryTableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'section': json['section'] == null ? undefined : json['section'],
        'schema': ((json['schema'] as Array<any>).map(SummaryTableTittleDtoFromJSON)),
        'aggregatedData': json['aggregatedData'] == null ? undefined : json['aggregatedData'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function DrmSummaryTableDtoToJSON(value?: DrmSummaryTableDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'section': value['section'],
        'schema': ((value['schema'] as Array<any>).map(SummaryTableTittleDtoToJSON)),
        'aggregatedData': value['aggregatedData'],
        'data': value['data'],
    };
}

